class UrlHelper {
  createQueryStringWithLimit(query: string, limit?: number): string {
    if (!query && !limit) {
      return ''
    }

    if (!limit && !!query) {
      return `?${query.replace('?', '')}`
    }

    if (!!limit && !query) {
      return `?limit=${limit}`
    }

    return `?limit=${limit}&${query.replace('?', '')}`
  }

  createQuery(arg: Record<string, string>) {
    const params = new URLSearchParams(arg)
    return params.toString()
  }

  paramsToObj(params: string) {
    const urlParams = new URLSearchParams(params)
    return Object.fromEntries(urlParams)
  }

  getQueryParam(search: string, key: string) {
    return new URLSearchParams(search).get(key) || ''
  }

  getQuery(search: string) {
    // TODO: Add multiple same query structure
    return Object.fromEntries(new URLSearchParams(search))
  }

  getFirstPathItem(path: string) {
    const val = path?.split?.('/')?.[1] || path?.split?.('/')?.[0] || ''
    return `/${val}`
  }

  getLastPathItem(path: string) {
    return path.split('/').pop()
  }
}

export default new UrlHelper()
